if (!customElements.get('islander-product-drawer')) {
  class IslanderProductDrawer extends HTMLElement {
    constructor() {
      super();
      this.dialog = this.querySelector('dialog');
      this.drawerId = this.dataset.drawerId || this.dialog?.id;
      this.activeTrigger = null;
      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
      this.handleDialogClick = this.handleDialogClick.bind(this);
      this.handleDialogClose = this.handleDialogClose.bind(this);
    }

    connectedCallback() {
      if (!this.dialog || !this.drawerId) return;

      this.refreshTriggers();
      this.querySelector('[data-islander-drawer-close]')?.addEventListener('click', this.handleCloseClick);
      this.dialog.addEventListener('click', this.handleDialogClick);
      this.dialog.addEventListener('close', this.handleDialogClose);
    }

    disconnectedCallback() {
      this.triggers?.forEach((trigger) => trigger.removeEventListener('click', this.handleTriggerClick));
      this.querySelector('[data-islander-drawer-close]')?.removeEventListener('click', this.handleCloseClick);
      this.dialog?.removeEventListener('click', this.handleDialogClick);
      this.dialog?.removeEventListener('close', this.handleDialogClose);
    }

    refreshTriggers() {
      this.triggers?.forEach((trigger) => trigger.removeEventListener('click', this.handleTriggerClick));
      this.triggers = document.querySelectorAll(`[data-islander-drawer-target="${CSS.escape(this.drawerId)}"]`);
      this.triggers.forEach((trigger) => {
        trigger.hidden = false;
        trigger.addEventListener('click', this.handleTriggerClick);
      });
    }

    handleTriggerClick(event) {
      this.open(event.currentTarget);
    }

    open(trigger) {
      if (this.dialog.open) return;

      this.activeTrigger = trigger;
      this.triggers.forEach((drawerTrigger) => drawerTrigger.setAttribute('aria-expanded', 'true'));
      document.documentElement.classList.add('islander-drawer-open');
      this.dialog.showModal();
    }

    handleCloseClick() {
      this.requestClose();
    }

    handleDialogClick(event) {
      if (event.target === this.dialog) this.requestClose();
    }

    requestClose() {
      if (this.dialog.open) this.dialog.close();
    }

    handleDialogClose() {
      this.triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      document.documentElement.classList.remove('islander-drawer-open');
      this.activeTrigger?.focus();
      this.activeTrigger = null;
    }
  }

  customElements.define('islander-product-drawer', IslanderProductDrawer);
}

function refreshIslanderProductDrawers() {
  document.querySelectorAll('[data-islander-drawer-target]').forEach((trigger) => {
    trigger.hidden = !document.getElementById(trigger.dataset.islanderDrawerTarget);
  });

  document.querySelectorAll('islander-product-drawer').forEach((drawer) => drawer.refreshTriggers());
}

refreshIslanderProductDrawers();
document.addEventListener('shopify:section:load', refreshIslanderProductDrawers);
document.addEventListener('shopify:section:unload', () => {
  requestAnimationFrame(refreshIslanderProductDrawers);
});
